<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('restaurant product catalog')"
      :columns="columns"
      :column_search="true"
      resource_url="/restaurant/product/datatables"
      mode="grid"
      grid_class="is-col-min-10"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div>
            <figure class="image is-64x64 m-auto">
              <v-lazy-image
                v-if="item.image"
                :src="`${api_host}/drive/static/${item.image}`"
              />
              <img
                v-else
                src="https://icon-library.com/images/product-icon-png/product-icon-png-11.jpg"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <div class="title is-5 has-text-centered">
                  {{ item.name }}
                </div>
                <div class="subtitle is-6 has-text-centered mb-0">
                  {{ item.settings.description }}
                </div>
                <div class="subtitle is-6 has-text-centered">
                  <span class="tag is-primary is-medium">{{
                    format_currency(item.settings.price)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div>
      </template>
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <product-modal ref="product_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import ProductModal from "./product_modal/Index.vue";

export default {
  name: "ProductDatatable",
  components: { GenericTable, ProductModal },
  data() {
    let v = this;
    return {
      api_host,
      columns: [
        {
          title: v.$t("data"),
          name: "data",
          searchable: true,
          width: "80%",
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.product_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete product?"),
                    v,
                    () => {
                      del("/restaurant/product", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.product_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.product_modal.edit_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete product?"),
        v,
        () => {
          del("/food/product", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
